import { FormattedMessage } from 'react-intl';

import { convertDateToUIString } from '../../../../../../utils/date/convert-date-to-string';
import { useCvBonusInfo } from '../../../../../../hooks';
import { useStyles } from './cv-banner.styles';

export const CvBanner = (): JSX.Element | null => {
  const classes = useStyles();
  const { cvBonusPoints, cvBonusEndDate } = useCvBonusInfo(true);

  if (!cvBonusPoints || !cvBonusEndDate) {
    return null;
  }

  return (
    <div className={classes.cvBanner} data-testid="cv-banner">
      <span className={classes.cvBannerIcon} aria-hidden="true" />
      <p className={classes.cvBannerText}>
        <FormattedMessage
          id="cv.banner.title"
          values={{
            points: cvBonusPoints,
            date: convertDateToUIString(cvBonusEndDate) ?? '',
          }}
        />
      </p>
    </div>
  );
};
